<template>
  <div>
    <Modal :title="showKeyModalTitle" v-model="showKeyModal" width="800" draggable>
      <div style="min-height: 500px">
        <Alert show-icon type="warning" v-if="isShowPrivateKey">私钥只显示一次，请妥善保存好！</Alert>
        <Input type="textarea" :rows="23" v-model="showKey" readonly />
      </div>
      <div slot="footer">
        <Button type="info" @click="keyCopy">拷贝到剪贴板</Button>
      </div>
    </Modal>
    <Card shadow>
      <Drawer
        :title="changeModalTitle"
        v-model="changeModal"
        width="500"
        @on-close="changeModalClose"
        :mask-closable="true">
        <Form :model="changeForm" ref="changeForm" :rules="changeRule" :label-width="90" label-position="right">
          <FormItem prop="name" label="名称">
            <Input v-model="changeForm.name" placeholder="密钥对名字只能由半角的字母、数字、空格、减号组成" :maxlength="128" />
          </FormItem>
          <FormItem prop="type" label="类型">
            <Select v-model="changeForm.type" :disabled="true">
              <Option value="ssh">ssh</Option>
              <Option value="x509">x509</Option>
            </Select>
          </FormItem>
          <FormItem label="上传密钥对" :label-width="100">
            <div style="float: left">
              <i-switch v-model="changeForm.is_self_generate">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </div>
            <Alert show-icon v-if="!changeForm.is_self_generate" style="float: left; margin-left: 10px">
              <span>如不上传密钥对：创建成功后，系统自动生成密钥对，将返回私钥，请妥善保存</span>
            </Alert>
          </FormItem>
          <FormItem prop="public_key" label="公钥" v-if="changeForm.is_self_generate">
            <Alert show-icon>可以使用 ssh-keygen 命令来生成SSH密钥对，请妥善保存好您的私钥，并把公钥文件内容粘贴在这里</Alert>
            <Input v-model="changeForm.public_key" placeholder="请粘贴公钥" type="textarea" :rows="16" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
            <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
      <Row>
        <Col style="float: left;">
          <Form ref="searchForm" inline @submit.native.prevent :model="searchForm" :label-width="80">
            <FormItem label="密钥对名称">
              <Input v-model="searchForm.name" style="min-width: 150px;" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getKeyPairData()">搜索</Button>
              <Button @click="searchFormReset" style="margin-left: 10px">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getKeyPairData(keypair.page)">刷新</Button>
          <Button
            @click="formReset('changeForm'); changeModal = true; changeModalTitle = '创建密钥对';"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建密钥对</Button>
        </div>
      </Row>
      <Table
        :loading="tableLoading"
        ref="table"
        :data="keypair.data"
        :columns="keypair.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ keypair.data.length }} 条记录，总共 {{ keypair.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="keypair.count"
            :current="keypair.page"
            :page-size="keypair.size"
            @on-change="getKeyPairData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudKeyPair, changePrivateCloudKeyPair, deletePrivateCloudKeyPair } from '@/api/private-cloud/keypair'

export default {
  data () {
    return {
      tableLoading: false,
      keypair: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '密钥对名称',
            align: 'center',
            minWidth: 100,
            key: 'name'
          },
          // {
          //   title: '类型',
          //   align: 'center',
          //   minWidth: 100,
          //   key: 'type'
          // },
          {
            title: '指纹',
            align: 'center',
            minWidth: 300,
            key: 'fingerprint'
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {

                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.isShowPrivateKey = false
                      this.showKeyModalTitle = params.row.name + ' - 公钥'
                      this.showKey = params.row.public_key
                      this.showKeyModal = true
                    }
                  }
                }, '查看公钥'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      changeModalTitle: '创建密钥对',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        name: '',
        type: 'ssh',
        is_self_generate: false,
        public_key: ''
      },
      changeRule: {
        name: [
          { required: true, message: '密钥对名称不能为空', trigger: 'blur' }
        ]
      },
      showKeyModalTitle: '',
      showKeyModal: false,
      showKey: '',
      isShowPrivateKey: false,
      searchForm: {
        name: ''
      }
    }
  },
  mounted: function () {
    this.getKeyPairData()
  },
  methods: {
    // 获取密钥对列表数据
    getKeyPairData (value = 1) {
      this.keypair.page = value
      let params = {
        page: this.keypair.page,
        size: this.keypair.size,
        name: this.searchForm.name
      }
      this.tableLoading = true
      getPrivateCloudKeyPair(params).then(res => {
        this.keypair.data = res.data.results
        this.keypair.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取密钥对列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取密钥对列表失败！'
          })
        }
      })
    },
    // 通用表单重置
    formReset (name) {
      this.$refs[name].resetFields()
    },
    // 提交镜像编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          if (this.changeForm.is_self_generate && !this.changeForm.public_key) {
            this.$Notice.warning({
              title: '提交失败，请粘贴公钥！'
            })
            return
          }
          this.changeLoading = true
          changePrivateCloudKeyPair(this.changeForm).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getKeyPairData()
            this.formReset('changeForm')
            this.changeLoading = false
            this.changeModal = false
            if (res.data.keypair && res.data.keypair.private_key) {
              this.isShowPrivateKey = true
              this.showKeyModalTitle = res.data.keypair.name + ' - 私钥'
              this.showKey = res.data.keypair.private_key
              this.showKeyModal = true
            }
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 删除密钥对
    delete (row) {
      deletePrivateCloudKeyPair(row.name).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getKeyPairData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 关闭编辑表单
    changeModalClose () {
      this.formReset('changeForm')
    },
    // 拷贝密钥到剪贴板
    keyCopy () {
      let that = this
      this.$copyText(this.showKey).then(function (e) {
        that.$Notice.success({ title: '拷贝成功！' })
      }, function (e) {
        that.$Notice.error({ title: '拷贝失败，请手动拷贝！' })
      })
    },
    // 重置搜索表单
    searchFormReset () {
      this.searchForm = {
        name: ''
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
